import { useState, useEffect } from "react";

export default function Disputes({ supabase }) {
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [selected, setSelected] = useState(null);
  const [resolution, setResolution] = useState("");
  const [adminNotes, setAdminNotes] = useState("");
  const [resolving, setResolving] = useState(false);

  useEffect(() => { loadDisputes(); }, []);

  async function loadDisputes() {
    const { data } = await supabase
      .from("disputes")
      .select("*, profiles(full_name, email, phone), orders(id, total_amount, order_type, status), shops(name, category)")
      .order("created_at", { ascending: false });
    if (data) setDisputes(data);
    setLoading(false);
  }

  async function resolveDispute(id, status) {
    if (!resolution.trim()) { alert("Please enter a resolution decision"); return; }
    setResolving(true);
    const { data: { session } } = await supabase.auth.getSession();
    await supabase.from("disputes").update({
      status,
      resolution: resolution.trim(),
      admin_notes: adminNotes.trim(),
      resolved_by: session?.user?.id,
      resolved_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    }).eq("id", id);
    setResolving(false);
    setSelected(null);
    setResolution("");
    setAdminNotes("");
    loadDisputes();
  }

  const statusColor = { open: "#f39c12", investigating: "#0057A8", resolved: "#00A651", closed: "#666" };
  const filtered = disputes.filter(d => filter === "all" || d.status === filter);

  const statCounts = {
    open: disputes.filter(d => d.status === "open").length,
    investigating: disputes.filter(d => d.status === "investigating").length,
    resolved: disputes.filter(d => d.status === "resolved").length,
    total: disputes.length,
  };

  const inputStyle = { background: "#1a1a1a", border: "1px solid #333", borderRadius: 8, padding: "10px 14px", color: "#fff", fontSize: 14, width: "100%", boxSizing: "border-box" };

  return (
    <div>
      {selected && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.85)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setSelected(null)}>
          <div style={{ background: "#111", border: "1px solid #333", borderRadius: 16, padding: 28, width: 560, maxHeight: "85vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <h2 style={{ color: "#fff", margin: 0 }}>Dispute Review</h2>
              <button style={{ background: "none", border: "none", color: "#666", fontSize: 20, cursor: "pointer" }} onClick={() => setSelected(null)}>✕</button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
              {[
                { label: "Dispute ID", value: "#" + selected.id.slice(0,8).toUpperCase() },
                { label: "Status", value: selected.status?.toUpperCase() },
                { label: "Type", value: selected.type },
                { label: "Filed", value: new Date(selected.created_at).toLocaleString() },
                { label: "Customer", value: selected.profiles?.full_name || "N/A" },
                { label: "Phone", value: selected.profiles?.phone || "N/A" },
                { label: "Email", value: selected.profiles?.email || "N/A" },
                { label: "Business", value: selected.shops?.name || "N/A" },
              ].map(f => (
                <div key={f.label} style={{ background: "#1a1a1a", borderRadius: 8, padding: 12 }}>
                  <div style={{ color: "#666", fontSize: 11, marginBottom: 4, textTransform: "uppercase" }}>{f.label}</div>
                  <div style={{ color: "#fff", fontSize: 14, fontWeight: "600" }}>{f.value}</div>
                </div>
              ))}
            </div>

            {selected.orders && (
              <div style={{ background: "#1a1a1a", borderRadius: 8, padding: 12, marginBottom: 16 }}>
                <div style={{ color: "#666", fontSize: 11, marginBottom: 6, textTransform: "uppercase" }}>Linked Order</div>
                <div style={{ color: "#fff", fontSize: 14 }}>#{selected.orders.id?.slice(0,8).toUpperCase()} · {selected.orders.order_type} · Le {selected.orders.total_amount?.toLocaleString()} · <span style={{ textTransform: "capitalize" }}>{selected.orders.status}</span></div>
              </div>
            )}

            {selected.description && (
              <div style={{ background: "#1a1a1a", borderRadius: 8, padding: 12, marginBottom: 16 }}>
                <div style={{ color: "#666", fontSize: 11, marginBottom: 6, textTransform: "uppercase" }}>Customer Description</div>
                <div style={{ color: "#ccc", fontSize: 14, lineHeight: 1.6 }}>{selected.description}</div>
              </div>
            )}

            {selected.resolution && (
              <div style={{ background: "#00A65115", border: "1px solid #00A65140", borderRadius: 8, padding: 12, marginBottom: 16 }}>
                <div style={{ color: "#00A651", fontSize: 12, fontWeight: "600", marginBottom: 6 }}>✅ Resolution</div>
                <div style={{ color: "#ccc", fontSize: 14 }}>{selected.resolution}</div>
                {selected.admin_notes && <div style={{ color: "#666", fontSize: 13, marginTop: 8 }}>Notes: {selected.admin_notes}</div>}
                {selected.resolved_at && <div style={{ color: "#666", fontSize: 12, marginTop: 6 }}>Resolved: {new Date(selected.resolved_at).toLocaleString()}</div>}
              </div>
            )}

            {selected.status !== "resolved" && selected.status !== "closed" && (
              <div>
                <div style={{ color: "#fff", fontSize: 15, fontWeight: "600", marginBottom: 12 }}>Make a Decision</div>
                <div style={{ marginBottom: 12 }}>
                  <label style={{ color: "#666", fontSize: 12, display: "block", marginBottom: 6 }}>RESOLUTION DECISION *</label>
                  <textarea style={{ ...inputStyle, height: 80, resize: "vertical" }}
                    placeholder="e.g. Refund approved. Customer will receive full refund within 3 business days..."
                    value={resolution} onChange={e => setResolution(e.target.value)} />
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ color: "#666", fontSize: 12, display: "block", marginBottom: 6 }}>INTERNAL NOTES (optional)</label>
                  <textarea style={{ ...inputStyle, height: 60, resize: "vertical" }}
                    placeholder="Internal notes not visible to customer..."
                    value={adminNotes} onChange={e => setAdminNotes(e.target.value)} />
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button style={{ flex: 1, background: "#00A651", border: "none", borderRadius: 8, padding: "12px", color: "#fff", fontWeight: "600", fontSize: 14, cursor: "pointer" }}
                    onClick={() => resolveDispute(selected.id, "resolved")} disabled={resolving}>
                    {resolving ? "Saving..." : "✅ Mark Resolved"}
                  </button>
                  <button style={{ flex: 1, background: "#0057A820", border: "1px solid #0057A8", borderRadius: 8, padding: "12px", color: "#0057A8", fontWeight: "600", fontSize: 14, cursor: "pointer" }}
                    onClick={() => resolveDispute(selected.id, "investigating")} disabled={resolving}>
                    🔍 Investigating
                  </button>
                  <button style={{ flex: 1, background: "#33333340", border: "1px solid #444", borderRadius: 8, padding: "12px", color: "#666", fontWeight: "600", fontSize: 14, cursor: "pointer" }}
                    onClick={() => resolveDispute(selected.id, "closed")} disabled={resolving}>
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div style={{ display: "flex", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
        {[
          { label: "Open", value: statCounts.open, color: "#f39c12" },
          { label: "Investigating", value: statCounts.investigating, color: "#0057A8" },
          { label: "Resolved", value: statCounts.resolved, color: "#00A651" },
          { label: "Total", value: statCounts.total, color: "#fff" },
        ].map(s => (
          <div key={s.label} style={{ background: "#111", border: "1px solid #222", borderRadius: 12, padding: 20, flex: 1, minWidth: 100, textAlign: "center" }}>
            <div style={{ color: s.color, fontSize: 28, fontWeight: "bold" }}>{s.value}</div>
            <div style={{ color: "#666", fontSize: 13 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
        {["all", "open", "investigating", "resolved", "closed"].map(f => (
          <button key={f} style={{ background: filter === f ? "#00A65120" : "#111", border: filter === f ? "1px solid #00A651" : "1px solid #333", borderRadius: 20, padding: "6px 14px", color: filter === f ? "#00A651" : "#666", cursor: "pointer", fontSize: 13 }} onClick={() => setFilter(f)}>
            {f === "all" ? "All" : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {loading ? <div style={{ color: "#666", textAlign: "center", padding: 40 }}>Loading disputes...</div> : filtered.length === 0 ? (
        <div style={{ color: "#666", textAlign: "center", padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
          <div>No {filter === "all" ? "" : filter} disputes</div>
        </div>
      ) : (
        <div style={{ background: "#111", border: "1px solid #222", borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>{["ID","Type","Customer","Business","Order","Filed","Status",""].map(h => (
                <th key={h} style={{ color: "#666", fontSize: 12, fontWeight: "600", textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #222", textTransform: "uppercase", background: "#0a0a0a" }}>{h}</th>
              ))}</tr>
            </thead>
            <tbody>
              {filtered.map(d => (
                <tr key={d.id} style={{ borderBottom: "1px solid #1a1a1a", cursor: "pointer" }} onClick={() => { setSelected(d); setResolution(d.resolution || ""); setAdminNotes(d.admin_notes || ""); }}>
                  <td style={{ color: "#00A651", fontSize: 13, padding: "12px 16px", fontFamily: "monospace" }}>#{d.id.slice(0,8).toUpperCase()}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{d.type}</td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>
                    <div style={{ color: "#fff" }}>{d.profiles?.full_name || "N/A"}</div>
                    <div style={{ fontSize: 12, color: "#666" }}>{d.profiles?.phone || ""}</div>
                  </td>
                  <td style={{ color: "#ccc", fontSize: 14, padding: "12px 16px" }}>{d.shops?.name || "—"}</td>
                  <td style={{ color: "#ccc", fontSize: 13, padding: "12px 16px", fontFamily: "monospace" }}>{d.order_id ? "#" + d.order_id.slice(0,8).toUpperCase() : "—"}</td>
                  <td style={{ color: "#ccc", fontSize: 13, padding: "12px 16px" }}>{new Date(d.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: "600", background: (statusColor[d.status] || "#999") + "20", color: statusColor[d.status] || "#999", textTransform: "capitalize" }}>{d.status}</span>
                  </td>
                  <td style={{ padding: "12px 16px" }}>
                    <button style={{ background: "#0057A820", color: "#0057A8", border: "1px solid #0057A840", borderRadius: 6, padding: "5px 12px", fontSize: 12, fontWeight: "600", cursor: "pointer" }}>Review →</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
